import * as React from 'react';
import VerticalTabsItem from '../VerticalTabsItem';

export interface VerticalTabsProps {
  children?: React.ReactNode;
  size?: VerticalTabsSize;
  activeTabId?: number;
  onChange?: (id: number) => void;
  dataHook?: string;
}

export type VerticalTabsSize = 'tiny' | 'small' | 'medium';

declare const Footer: React.FC<{
  children?: React.ReactNode;
}>;

export interface TabsGroup {
  children?: React.ReactNode;
  title?: string;
}
declare const TabsGroup: React.FC<TabsGroup>;

export default class VerticalTabs extends React.Component<VerticalTabsProps> {
  static Footer: typeof Footer;
  static TabsGroup: typeof TabsGroup;
  static TabItem: typeof VerticalTabsItem;
}
